// // // import React, { type ReactNode } from 'react';
// // // import { useTranslation } from 'react-i18next';

// // // // ________________________________________________________________________________

// // // interface LoadingProps {
// // //   loading: boolean;
// // //   error?: string | any;
// // //   children?: ReactNode;
// // //   Type?: 'Logo' | 'Dots';
// // // }

// // // const Loading: React.FC<LoadingProps> = ({ loading, error, children, Type }) => {
// // //   const { i18n } = useTranslation();

// // //   const renderHandler = () => {
// // //     return (
// // //       <>
// // //         {loading ? (
// // //           <>
// // //             {Type === 'Dots' ? (
// // //               <div className='dots-loader'>
// // //                 <div className='dot dot-1'></div>
// // //                 <div className='dot dot-2'></div>
// // //                 <div className='dot dot-3'></div>
// // //               </div>
// // //             ) : (
// // //               <div className='logo-loader-container'>
// // //                 <div className='logo-loader'>
// // //                   <div className='logo-loader-inner'></div>
// // //                 </div>
// // //                 <p>{i18n.language === 'en' ? 'Loading...' : 'جاري التحميل...'}</p>
// // //               </div>
// // //             )}
// // //           </>
// // //         ) : error ? (
// // //           <div className='error-container'>
// // //             <div className='error-icon mb-2'>
// // //               <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
// // //                 <path d='M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z' />
// // //               </svg>
// // //             </div>
// // //             <h3>{i18n.language === 'en' ? 'Sorry, an error occurred!' : 'عذراً، حدث خطأ!'}</h3>
// // //             <div className='error-message-container px-2 py-1 bg-theme bg-opacity-20 border-1 border border-theme '>
// // //               <p className='error-message  mb-0'>{typeof error === 'string' ? error : error?.message}</p>
// // //               {/* <p className='error-message   '>{typeof error === 'string' ? error : JSON.stringify(error) }</p> */}
// // //             </div>
// // //             <button className='reload-button btn btn-theme btn-sm' onClick={() => window.location.reload()}>
// // //               <i className='bi bi-arrow-clockwise me-1'></i>
// // //               {i18n.language === 'en' ? 'Reload Page' : 'إعادة تحميل الصفحة'}
// // //             </button>
// // //           </div>
// // //         ) : (
// // //           children
// // //         )}

// // //         <style>
// // //           {`
// // //             .dots-loader {
// // //               display: flex;
// // //               justify-content: center;
// // //               align-items: center;
// // //               height: 200px;
// // //               gap: 8px;
// // //             }

// // //             .dot {
// // //               width: 16px;
// // //               height: 16px;
// // //               border-radius: 50%;
// // //               animation: pulse 1.5s ease-in-out infinite;
// // //             }

// // //             .dot-1 {
// // //               background-color: #4CAF50;
// // //               animation-delay: 0s;
// // //             }

// // //             .dot-2 {
// // //               background-color: #FF5722;
// // //               animation-delay: 0.3s;
// // //             }

// // //             .dot-3 {
// // //               background-color: #FFC107;
// // //               animation-delay: 0.6s;
// // //             }

// // //             @keyframes pulse {
// // //               0%, 100% {
// // //                 transform: scale(0.8);
// // //                 opacity: 0.7;
// // //               }
// // //               50% {
// // //                 transform: scale(1.2);
// // //                 opacity: 1;
// // //               }
// // //             }

// // //             .logo-loader-container {
// // //               display: flex;
// // //               flex-direction: column;
// // //               justify-content: center;
// // //               align-items: center;
// // //               height: 300px;
// // //             }

// // //             .logo-loader {
// // //               width: 80px;
// // //               height: 80px;
// // //               border: 4px solid #f3f3f3;
// // //               border-top: 4px solid #3498db;
// // //               border-radius: 50%;
// // //               animation: spin 1s linear infinite;
// // //               margin-bottom: 16px;
// // //             }

// // //             .logo-loader-inner {
// // //               width: 60px;
// // //               height: 60px;
// // //               border: 4px solid transparent;
// // //               border-right: 4px solid #e74c3c;
// // //               border-radius: 50%;
// // //               animation: spinReverse 1.5s linear infinite;
// // //               margin: 6px;
// // //             }

// // //             @keyframes spin {
// // //               0% { transform: rotate(0deg); }
// // //               100% { transform: rotate(360deg); }
// // //             }

// // //             @keyframes spinReverse {
// // //               0% { transform: rotate(0deg); }
// // //               100% { transform: rotate(-360deg); }
// // //             }

// // //             /* أنماط عرض الخطأ المحسنة */
// // //             .error-container {
// // //               display: flex;
// // //               flex-direction: column;
// // //               align-items: center;
// // //               justify-content: center;
// // //               text-align: center;
// // //               // min-height: 300px;
// // //               padding: 20px;
// // //             }

// // //             .error-icon {
// // //               width: 80px;
// // //               height: 80px;
// // //               color: #e74c3c;
// // //               margin-bottom: 20px;
// // //               animation: bounce 1s infinite alternate;
// // //             }

// // //             @keyframes bounce {
// // //               0% { transform: translateY(0); }
// // //               100% { transform: translateY(-8px); }
// // //             }

// // //             .error-container h3 {
// // //               margin-bottom: 15px;
// // //               font-size: 22px;
// // //               color: #d9534f;
// // //             }

// // //             .error-message-container {
// // //               max-width: 500px;
// // //               margin-bottom: 20px;
// // //               // background-color: #f8d7da;
// // //               // border: 1px solid #f5c6cb;
// // //               border-radius: 8px;
// // //               // padding: 8px 12px;
// // //               max-height: 100px;
// // //               overflow-y: auto;
// // //               word-wrap: break-word;
// // //             }

// // //             .error-message {
// // //               font-size: 0.6rem;
// // //               // color: #721c24;
// // //               margin: 0;
// // //               line-height: 1.5;
// // //               text-align: center;
// // //               word-break: break-word;
// // //               overflow-wrap: break-word;
// // //             }

// // //             .reload-button {
// // //               color: white;
// // //               border: none;
// // //               border-radius: 6px;
// // //               cursor: pointer;
// // //               transition: background-color 0.3s, transform 0.2s;
// // //             }

// // //             .reload-button:hover {
// // //               background-color: #2980b9;
// // //               transform: translateY(-2px);
// // //             }

// // //             .reload-button:active {
// // //               transform: translateY(0);
// // //             }

// // //             /* شريط التمرير المخصص لرسائل الخطأ الطويلة */
// // //             .error-message-container::-webkit-scrollbar {
// // //               width: 8px;
// // //             }

// // //             .error-message-container::-webkit-scrollbar-track {
// // //               background: #f1f1f1;
// // //               border-radius: 4px;
// // //             }

// // //             .error-message-container::-webkit-scrollbar-thumb {
// // //               background: #c1c1c1;
// // //               border-radius: 4px;
// // //             }

// // //             .error-message-container::-webkit-scrollbar-thumb:hover {
// // //               background: #a8a8a8;
// // //             }

// // //             /* تكيف مع الشاشات الصغيرة */
// // //             @media (max-width: 576px) {
// // //               .error-container {
// // //                 padding: 15px;
// // //               }

// // //               .error-message-container {
// // //                 max-width: 100%;
// // //                 padding: 10px;
// // //                 max-height: 150px;
// // //               }

// // //               .error-icon {
// // //                 width: 60px;
// // //                 height: 60px;
// // //               }

// // //               .error-container h3 {
// // //                 font-size: 18px;
// // //               }
// // //             }
// // //           `}
// // //         </style>
// // //       </>
// // //     );
// // //   };

// // //   return renderHandler();
// // // };

// // // export default React.memo(Loading);

// // import React, { type ReactNode } from 'react';
// // import { useTranslation } from 'react-i18next';

// // interface LoadingProps {
// //   loading: boolean;
// //   error?: string | any;
// //   children?: ReactNode;
// //   Type?: 'Logo' | 'Dots';
// // }

// // const Loading: React.FC<LoadingProps> = ({ loading, error, children, Type }) => {
// //   const { i18n } = useTranslation();
// //   const isAr = i18n.language === 'ar';

// //   if (!loading && !error) return <>{children}</>;

// //   return (
// //     <div className="neatix-loading-system">
// //       {loading ? (
// //         <div className="loader-box">
// //           {Type === 'Dots' ? (
// //             <div className="neatix-dots">
// //               <span></span>
// //               <span></span>
// //               <span></span>
// //             </div>
// //           ) : (
// //             <div className="neatix-brand-loader">
// //               <div className="main-ring"></div>
// //               <div className="sub-ring"></div>
// //               {/* أيقونة هندسية مستوحاة من شعار NEATIX */}
// //               <div className="logo-symbol">
// //                 <div className="diamond-shape"></div>
// //               </div>
// //             </div>
// //           )}
// //           <p className="status-text">{isAr ? 'جاري تجهيز البيانات' : 'Preparing data '}</p>
// //         </div>
// //       ) : (
// //         <div className="neatix-error-card">
// //           <div className="error-header">
// //              <i className="bi bi-shield-exclamation"></i>
// //           </div>
// //           <h3>{isAr ? 'توقف النظام مؤقتاً' : 'System Paused'}</h3>
// //           <div className="error-info">
// //              <p>{typeof error === 'string' ? error : error?.message || 'Technical issue occurred'}</p>
// //           </div>
// //           <button className="neatix-btn" onClick={() => window.location.reload()}>
// //             <i className="bi bi-arrow-repeat"></i>
// //             {isAr ? 'تحديث النظام' : 'Reload System'}
// //           </button>
// //         </div>
// //       )}

// //       <style>{`
// //         :root {
// //           --neatix-theme: var(--bs-theme );
// //           --neatix-bg-soft: rgba(var(--bs-theme-rgb, 0, 123, 255), 0.1);
// //         }

// //         .neatix-loading-system {
// //           display: flex;
// //           justify-content: center;
// //           align-items: center;
// //           min-height: 400px;
// //           animation: fadeIn 0.5s ease;
// //         }

// //         /* --- Brand Loader UI --- */
// //         .neatix-brand-loader {
// //           position: relative;
// //           width: 100px;
// //           height: 100px;
// //           display: flex;
// //           justify-content: center;
// //           align-items: center;
// //           margin-bottom: 2rem;
// //         }

// //         .main-ring {
// //           position: absolute;
// //           width: 100%;
// //           height: 100%;
// //           border: 2px solid var(--neatix-bg-soft);
// //           border-top: 2px solid var(--bs-theme);
// //           border-radius: 50%;
// //           animation: neatix-spin 1s cubic-bezier(0.4, 0, 0.2, 1) infinite;
// //         }

// //         .sub-ring {
// //           position: absolute;
// //           width: 75%;
// //           height: 75%;
// //           border: 1.5px solid transparent;
// //           border-right: 1.5px solid var(--bs-theme);
// //           border-radius: 50%;
// //           opacity: 0.4;
// //           animation: neatix-spin-reverse 2s linear infinite;
// //         }

// //         .logo-symbol {
// //           position: relative;
// //           width: 30px;
// //           height: 30px;
// //           background: var(--bs-theme);
// //           transform: rotate(45deg); /* تحويل المربع إلى معين مثل الشعار */
// //           box-shadow: 0 0 20px var(--bs-theme);
// //           animation: logo-pulse 1.5s ease-in-out infinite;
// //           border: 3px solid #fff;
// //         }

// //         /* --- Status Text --- */
// //         .status-text {
// //           font-weight: 600;
// //           color: #475569;
// //           font-size: 1rem;
// //           letter-spacing: 1px;
// //           text-align: center;
// //         }

// //         /* --- Dots Version --- */
// // .neatix-dots {
// //           display: flex;
// //           gap: 15px;
// //           margin-bottom: 1.5rem;
// //           padding: 10px;
// //         }

// //         .neatix-dots span {
// //           width: 14px;
// //           height: 14px;
// //           background: var(--bs-theme);
// //           border-radius: 3px; /* زوايا منحنية قليلاً للمعينات */
// //           transform: rotate(45deg) scale(0.5);
// //           opacity: 0.1;
// //           /* حركة الوميض المتسلسل */
// //           animation: neatix-modern-dots 1.4s infinite ease-in-out;
// //           box-shadow: 0 0 10px rgba(var(--bs-theme-rgb), 0);
// //           transition: all 0.3s ease;
// //         }

// //         /* تأخير زمني لكل نقطة لخلق تأثير الموجة */
// //         .neatix-dots span:nth-child(1) { animation-delay: 0s; }
// //         .neatix-dots span:nth-child(2) { animation-delay: 0.2s; }
// //         .neatix-dots span:nth-child(3) { animation-delay: 0.4s; }

// //         @keyframes neatix-modern-dots {
// //           0%, 100% {
// //             transform: rotate(45deg) scale(0.6);
// //             opacity: 0.2;
// //             filter: blur(1px);
// //           }
// //           50% {
// //             transform: rotate(45deg) scale(1.2); /* تكبير المعين */
// //             opacity: 1;
// //             filter: blur(0px);
// //             box-shadow: 0 0 15px var(--bs-theme); /* توهج عند الذروة */
// //             border-radius: 1px; /* يصبح حاداً أكثر عند التكبير */
// //           }
// //         }

// //         /* --- Error Card UI --- */
// //         .neatix-error-card {
// //           background: #fff;
// //           padding: 2.5rem;
// //           border-radius: 16px;
// //           box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.08);
// //           border-bottom: 4px solid #ef4444;
// //           text-align: center;
// //           max-width: 400px;
// //         }

// //         .error-header {
// //           font-size: 3rem;
// //           color: #ef4444;
// //           margin-bottom: 1rem;
// //         }

// //         .error-info {
// //           background: #fdf2f2;
// //           border-radius: 8px;
// //           padding: 1rem;
// //           margin-bottom: 1.5rem;
// //           font-family: monospace;
// //           font-size: 0.85rem;
// //         }

// //         .neatix-btn {
// //           background: var(--bs-theme);
// //           color: white;
// //           border: none;
// //           padding: 12px 30px;
// //           border-radius: 8px;
// //           font-weight: bold;
// //           transition: all 0.3s ease;
// //           cursor: pointer;
// //         }

// //         /* --- Keyframes --- */
// //         @keyframes neatix-spin {
// //           from { transform: rotate(0deg); }
// //           to { transform: rotate(360deg); }
// //         }

// //         @keyframes neatix-spin-reverse {
// //           from { transform: rotate(0deg); }
// //           to { transform: rotate(-360deg); }
// //         }

// //         @keyframes logo-pulse {
// //           0%, 100% { transform: rotate(45deg) scale(0.9); opacity: 0.8; }
// //           50% { transform: rotate(45deg) scale(1.1); opacity: 1; }
// //         }

// //         @keyframes neatix-jump {
// //           0%, 100% { transform: rotate(45deg) translateY(0); }
// //           50% { transform: rotate(45deg) translateY(-10px); }
// //         }

// //         @keyframes fadeIn {
// //           from { opacity: 0; } to { opacity: 1; }
// //         }
// //       `}</style>
// //     </div>
// //   );
// // };

// // export default React.memo(Loading);

// import React, { type ReactNode } from 'react';
// import { useTranslation } from 'react-i18next';

// interface LoadingProps {
//   loading: boolean;
//   error?: string | any;
//   children?: ReactNode;
//   Type?: 'Logo' | 'Dots';
// }

// const Loading: React.FC<LoadingProps> = ({ loading, error, children, Type }) => {
//   const { i18n } = useTranslation();
//   const isAr = i18n.language === 'ar';

//   if (!loading && !error) return <>{children}</>;

//   return (
//     <div className="neatix-loading-system">
//       {loading ? (
//         <div className="loader-box">
//           {Type === 'Dots' ? (
//             <div className="neatix-dots">
//               <span></span>
//               <span></span>
//               <span></span>
//             </div>
//           ) : (
//             <div className="neatix-brand-loader">
//               <div className="main-ring"></div>
//               <div className="sub-ring"></div>
//               {/* المعين المركزي مضبوط برياضيات دقيقة ليتوسط الحلقات */}
//               <div className="logo-symbol"></div>
//             </div>
//           )}
//           <p className="status-text">
//             {isAr ? 'جاري تجهيز البيانات' : 'Preparing data'}
//           </p>
//         </div>
//       ) : (
//         <div className="neatix-error-card">
//           <div className="error-header">
//             <i className="bi bi-shield-exclamation"></i>
//           </div>
//           <h3>{isAr ? 'توقف النظام مؤقتاً' : 'System Paused'}</h3>
//           <div className="error-info">
//             <p>{typeof error === 'string' ? error : error?.message || 'Technical issue occurred'}</p>
//           </div>
//           <button className="neatix-btn" onClick={() => window.location.reload()}>
//             <i className="bi bi-arrow-repeat"></i>
//             {isAr ? 'تحديث النظام' : 'Reload System'}
//           </button>
//         </div>
//       )}

//       <style>{`
//         :root {
//           --neatix-theme: var(--bs-theme, #007bff);
//           --neatix-bg-soft: rgba(var(--bs-theme-rgb, 0, 123, 255), 0.1);
//         }

//         .neatix-loading-system {
//           display: flex;
//           justify-content: center;
//           align-items: center;
//           min-height: 400px;
//           width: 100%;
//           animation: fadeIn 0.5s ease;
//         }

//         .loader-box {
//           display: flex;
//           flex-direction: column;
//           align-items: center;
//           justify-content: center;
//           text-align: center;
//         }

//         /* --- Brand Loader (Logo Type) --- */
//         .neatix-brand-loader {
//           position: relative;
//           width: 100px;
//           height: 100px;
//           display: flex;
//           justify-content: center;
//           align-items: center;
//           margin-bottom: 1.5rem;
//         }

//         .main-ring {
//           position: absolute;
//           width: 100%;
//           height: 100%;
//           border: 2px solid var(--neatix-bg-soft);
//           border-top: 2px solid var(--bs-theme);
//           border-radius: 50%;
//           animation: neatix-spin 1s cubic-bezier(0.4, 0, 0.2, 1) infinite;
//         }

//         .sub-ring {
//           position: absolute;
//           width: 70%;
//           height: 70%;
//           border: 1.5px solid transparent;
//           border-right: 1.5px solid var(--bs-theme);
//           border-radius: 50%;
//           opacity: 0.4;
//           animation: neatix-spin-reverse 2s linear infinite;
//         }

//         .logo-symbol {
//           position: absolute;
//           /* التوسيط المطلق للمعين */
//           top: 50%;
//           left: 50%;
//           width: 28px;
//           height: 28px;
//           margin-top: -14px;
//           margin-left: -14px;
//           background: var(--bs-theme);
//           transform: rotate(45deg);
//           box-shadow: 0 0 15px var(--bs-theme);
//           animation: logo-pulse 1.5s ease-in-out infinite;
//           border: 3px solid #fff;
//           z-index: 2;
//         }

//         /* --- Dots Version (The one you liked) --- */
//         .neatix-dots {
//           display: flex;
//           gap: 15px;
//           margin-bottom: 1.5rem;
//           padding: 10px;
//           justify-content: center;
//         }

//         .neatix-dots span {
//           width: 14px;
//           height: 14px;
//           background: var(--bs-theme);
//           border-radius: 3px;
//           transform: rotate(45deg) scale(0.5);
//           opacity: 0.1;
//           animation: neatix-modern-dots 1.4s infinite ease-in-out;
//         }

//         .neatix-dots span:nth-child(1) { animation-delay: 0s; }
//         .neatix-dots span:nth-child(2) { animation-delay: 0.2s; }
//         .neatix-dots span:nth-child(3) { animation-delay: 0.4s; }

//         @keyframes neatix-modern-dots {
//           0%, 100% {
//             transform: rotate(45deg) scale(0.6);
//             opacity: 0.2;
//             filter: blur(1px);
//           }
//           50% {
//             transform: rotate(45deg) scale(1.2);
//             opacity: 1;
//             filter: blur(0px);
//             box-shadow: 0 0 15px var(--bs-theme);
//           }
//         }

//         /* --- Typography & UI --- */
//         .status-text {
//           font-weight: 600;
//           color: #475569;
//           font-size: 0.95rem;
//           margin: 0;
//           letter-spacing: 0.5px;
//           animation: text-pulse 1.5s ease-in-out infinite;
//         }

//         .neatix-error-card {
//           background: #fff;
//           padding: 2.5rem;
//           border-radius: 20px;
//           box-shadow: 0 20px 40px rgba(0, 0, 0, 0.05);
//           border-bottom: 4px solid #ef4444;
//           text-align: center;
//           max-width: 400px;
//         }

//         .error-header {
//           font-size: 3rem;
//           color: #ef4444;
//           margin-bottom: 1rem;
//         }

//         .error-info {
//           background: #f8fafc;
//           border-radius: 12px;
//           padding: 1rem;
//           margin-bottom: 1.5rem;
//           border: 1px solid #e2e8f0;
//         }

//         .neatix-btn {
//           background: var(--bs-theme);
//           color: white;
//           border: none;
//           padding: 12px 35px;
//           border-radius: 10px;
//           font-weight: bold;
//           transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
//           cursor: pointer;
//           display: inline-flex;
//           align-items: center;
//           gap: 8px;
//         }

//         .neatix-btn:hover {
//           transform: translateY(-3px);
//           box-shadow: 0 10px 20px rgba(var(--bs-theme-rgb), 0.3);
//           filter: brightness(1.1);
//         }

//         /* --- Keyframes --- */
//         @keyframes neatix-spin {
//           from { transform: rotate(0deg); } to { transform: rotate(360deg); }
//         }

//         @keyframes neatix-spin-reverse {
//           from { transform: rotate(0deg); } to { transform: rotate(-360deg); }
//         }

//         @keyframes logo-pulse {
//           0%, 100% { transform: rotate(45deg) scale(0.9); box-shadow: 0 0 10px var(--bs-theme); }
//           50% { transform: rotate(45deg) scale(1.1); box-shadow: 0 0 25px var(--bs-theme); }
//         }

//         @keyframes text-pulse {
//           0%, 100% { opacity: 0.7; }
//           50% { opacity: 1; }
//         }

//         @keyframes fadeIn {
//           from { opacity: 0; transform: translateY(10px); }
//           to { opacity: 1; transform: translateY(0); }
//         }
//       `}</style>
//     </div>
//   );
// };

// export default React.memo(Loading);

import React, { type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

interface LoadingProps {
  loading: boolean;
  error?: string | any;
  children?: ReactNode;
  Type?: 'Logo' | 'Dots';
}

const Loading: React.FC<LoadingProps> = ({ loading, error, children, Type }) => {
  const { i18n } = useTranslation();
  const isAr = i18n.language === 'ar';

  if (!loading && !error) return <>{children}</>;

  return (
    <div
      className='neatix-loading-system container d-flex justify-content-center align-items-center'
      style={{ minHeight: '300px' }}
    >
      {loading ? (
        <div className='loader-box'>
          {Type === 'Dots' ? (
            <div className='neatix-dots'>
              <span></span>
              <span></span>
              <span></span>
            </div>
          ) : (
            <div className='neatix-brand-loader'>
              <div className='main-ring'></div>
              <div className='sub-ring'></div>
              <div className='logo-symbol'></div>
            </div>
          )}
          <p className='status-text mt-3'>{isAr ? 'جاري تجهيز البيانات' : 'Preparing data'}</p>
        </div>
      ) : (
        /* --- كارت الخطأ البسيط الذي طلبته --- */
        <div className='error-container text-center p-4'>
          <div className='error-icon mb-3' style={{ fill: 'var(--bs-theme, #dc3545)' }}>
            <svg xmlns='http://www.w3.org/2000/svg' width='60' height='60' viewBox='0 0 24 24'>
              <path d='M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z' />
            </svg>
          </div>
          <h4 className='fw-bold mb-3'>{isAr ? 'عذراً، حدث خطأ!' : 'Sorry, an error occurred!'}</h4>
          <div
            className='error-message-container px-3 py-2 bg-theme bg-opacity-10 border border-theme rounded mb-4'
            style={{ borderStyle: 'dashed !important', maxWidth: '400px' }}
          >
            <p className='error-message mb-0 small text-muted text-break'>
              {typeof error === 'string' ? error : error?.message || 'Unknown error'}
            </p>
          </div>
          <button className='btn btn-theme btn-sm px-4 py-2 fw-bold' onClick={() => window.location.reload()}>
            <i className='bi bi-arrow-clockwise me-1'></i>
            {isAr ? 'إعادة تحميل الصفحة' : 'Reload Page'}
          </button>
        </div>
      )}

      <style>{`
   

        /* تنسيقات الـ Loader (الهوية البصرية) */
        .loader-box { display: flex; flex-direction: column; align-items: center; }
        .neatix-brand-loader { position: relative; width: 80px; height: 80px; display: flex; justify-content: center; align-items: center; }
        .main-ring { position: absolute; width: 100%; height: 100%; border: 2px solid rgba(var(--bs-theme-rgb), 0.1); border-top: 2px solid var(--bs-theme); border-radius: 50%; animation: n-spin 1s infinite linear; }
        .sub-ring { position: absolute; width: 70%; height: 70%; border: 1.2px solid transparent; border-right: 1.2px solid var(--bs-theme); border-radius: 50%; opacity: 0.4; animation: n-spin-rev 2s linear infinite; }
        .logo-symbol { position: absolute; top: 50%; left: 50%; width: 22px; height: 22px; margin-top: -11px; margin-left: -11px; background: var(--bs-theme); transform: rotate(45deg); box-shadow: 0 0 15px var(--bs-theme); animation: l-pulse 1.5s ease-in-out infinite; border: 2.5px solid #fff; z-index: 2; }

        /* تنسيقات النقاط المتموجة */
        .neatix-dots { display: flex; gap: 12px; }
        .neatix-dots span { width: 12px; height: 12px; background: var(--bs-theme); border-radius: 2px; transform: rotate(45deg) scale(0.6); opacity: 0.2; animation: d-wave 1.4s infinite ease-in-out; }
        .neatix-dots span:nth-child(2) { animation-delay: 0.2s; }
        .neatix-dots span:nth-child(3) { animation-delay: 0.4s; }

        /* أزرار Bootstrap مخصصة */
        .btn-theme { background-color: var(--bs-theme); color: white; border: none; }
        .btn-theme:hover { background-color: var(--bs-theme); filter: brightness(0.9); color: white; }
        .border-theme { border-color: var(--bs-theme) !important; }
        .bg-theme { background-color: var(--bs-theme); }

        /* الأنيميشن */
        @keyframes n-spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
        @keyframes n-spin-rev { from { transform: rotate(0deg); } to { transform: rotate(-360deg); } }
        @keyframes l-pulse { 0%, 100% { transform: rotate(45deg) scale(0.9); } 50% { transform: rotate(45deg) scale(1.1); } }
        @keyframes d-wave { 0%, 100% { transform: rotate(45deg) scale(0.6); opacity: 0.2; } 50% { transform: rotate(45deg) scale(1.2); opacity: 1; } }
        .status-text { color: #64748b; font-weight: 500; font-size: 0.9rem; }
      `}</style>
    </div>
  );
};

export default React.memo(Loading);
